/**
 * @fileOverview Cross
 */
import { PresentationAttributes } from '../util/types';

export type Props = PresentationAttributes<SVGElement>;

function Cell(props: Props): null {
  return null;
}
Cell.displayName = 'Cell';

export default Cell;
